/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 11/10/2023
 */

import { Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Styles from "./ServicesIntro.module.css";
import { isMobile } from 'react-device-detect';

const ServicesIntro = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/contact'); 
    };

    const image = `${process.env.REACT_APP_IMAGE_URL}DoneRight/PAGES/services.jpg`
    const imageMobile = `${process.env.REACT_APP_IMAGE_URL}DoneRight/PAGES/services-mobile.jpg`

    return (
        <div className={Styles.outerContainer}>
            <img className={Styles.mainImage} src={isMobile?imageMobile:image} alt="Alt" loading='lazy' />
            <div className={Styles.textContainer}>
                <Typography className={Styles.topic}>Services</Typography>
                <Typography className={Styles.description}>Revitalize your spaces with our specialized cleaning expertise. From offices to homes and gardens, we've got you covered. Experience the difference.</Typography>
                <Button variant='contained' color='primary' onClick={handleClick}>Let's Talk</Button>
            </div>
        </div>
    );
};

export default ServicesIntro;
